import "./loading.scss";
import Lottie from 'react-lottie';
import animationData from './loading-gsb.json';
import LinearProgress from '@mui/material/LinearProgress';
import Button from "@mui/material/Button";

const LoadingComponent = ({ message, isShowProgressBar = false, progress = 0, isShowCancelButton = false, onClose = () => { } }) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div className="loading-control">
            <Lottie options={defaultOptions}
                width={187}
                height={177}
            />

            {
                isShowProgressBar && <LinearProgress variant="determinate" className="progress-bar-control mt-4" value={progress} />
            }

            <span className="loading-title">กรุณารอสักครู่...</span>

            <span className="text-center" dangerouslySetInnerHTML={{ __html: message }}></span>

            {
                isShowCancelButton &&
                <Button
                    variant="outlined"
                    className="loading-control-cancel-button"
                    onClick={onClose}
                >
                    ยกเลิก
                </Button>
            }

        </div>
    )
}

export default LoadingComponent;